<template>
    <div class="header">
        <div class="header-s">
            <div class="header_left">
                <img @click="tohome" src="../assets/imgs/logo带字.png" alt="">
            </div>
            <div class="header_right">
                <div class="header_right_dis" v-if="userinfo">
                    <img src="../assets/imgs/user.png" alt="">
                    <t-dropdown :options="options" @click="clickHandler" :minColumnWidth="120">
                        <t-button variant="dashed" ghost>
                            <span class="tdesign-demo-dropdown__text">
                                {{username?username:orgname}} 
                            </span>
                        </t-button>
                    </t-dropdown>
                    <!-- <t-button theme="primary" style="margin-left:10px;">收藏夹</t-button> -->
                </div>
            </div>
        </div>
        
    </div>
</template>

<script>

export default {
    data(){
        return{
            type : window.localStorage.getItem('method'),
            options : [
            ],
            orgname :  window.localStorage.getItem('organ_name'),
            username: window.localStorage.getItem('name'),
            userinfo:true,
        }
    },
    mounted(){
        if(this.$route.name == 'login'||this.$route.name == 'registered'){
            this.userinfo = false
        }else{
            this.userinfo = true
        }
        if(this.type == 'IP'){
            this.options = [
                // {
                //     content: '个人账号登录',
                //     value: 1,
                // },
                // {
                //     content: '个人账号注册',
                //     value: 2,
                // },
                {
                    content: '退出',
                    value: 3,
                }
            ]
        }else if(this.type == 'user'){
            this.options = [
                // {
                //     content: '个人中心',
                //     value: 1,
                // },
                {
                    content: '退出',
                    value: 2,
                }
            ]
        }else{
            this.options = [
                // {
                //     content: '个人账号登录',
                //     value: 1,
                // },
                // {
                //     content: '个人账号注册',
                //     value: 2,
                // },
                {
                    content: '退出',
                    value: 3,
                }
            ]
        }

    },
    methods:{
        tohome(){
            this.$router.push({
                name:'home'
            })
        },  
        clickHandler(e){
            console.log(e.content);
            if(e.content == "退出"){
                window.localStorage.clear()
                localStorage.setItem('ipdl','1')
                this.$router.push({
                    name:'login'
                })
            }else if(e.content == "个人账号注册"){
                this.$router.push({
                    name:'registered'
                })
            }else if(e.content == "个人账号登录"){
                this.$router.push({
                    name:'login'
                })
            }else if(e.content == "个人中心"){
                this.$router.push({
                    name:'user'
                })
            }
        }
    }
    
}
</script>

<style scoped lang="less">
/deep/ .t-dropdown__item-content{
    justify-content: center !important;
}
.header{
    width:100%;
    height: 80px;
    background-color: rgba(0, 0, 0, 0.3);
    .header-s{
        width: 80%;
        height: 80px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .header_left{
            height: 100%;
            display: flex;
            align-items: center;
            span{
                color: #fff;
                font-size: 25px;
                cursor: pointer;
            }
            img{
                width: 180px;
                cursor: pointer;
            }
        }
        .header_right{
            height: 100%;
            display: flex;
            align-items: center;
            .header_right_dis{
                display: flex;
                align-items: center;
                img{
                    width: 35px;
                    margin-right: 10px;
                }
            }
        }
    }
     
}

</style>